import React, { useState, useEffect } from 'react';
import { Table, Container, Spinner, Alert, Badge, Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { format } from 'date-fns';
import { FaEdit, FaFilePdf } from 'react-icons/fa'; // Import the icon from React Icons
import apinode from '../../services/apinode';
import { Link } from 'react-router-dom';
import Navbar from '../../components/navbar/navbar.jsx'

const PendingOrders = () => {
    const [orders, setOrders] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchOrders = async () => {
            try {
                const response = await apinode.get(`/pedido/notchecked/${localStorage.idconta}`);
                setOrders(response.data);
                setLoading(false);
            } catch (error) {
                setError(error);
                setLoading(false);
            }
        };

        fetchOrders();
    }, []);

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        return format(date, 'dd/MM/yyyy');
    };

    const handleNfe = (loja, idnfe) => {
        // Build the URL
        const linkUrl = `/nfe/editar/${idnfe}`;
        // Open the link in a new tab
        window.open(linkUrl, '_blank');
    };

    const renderStatusBadge = (status) => {
        let variant;
        switch (status) {
            case 'Pendente':
                variant = 'warning';
                break;
            case 'Atendido':
                variant = 'success';
                break;
            case 'Cancelado':
                variant = 'danger';
                break;
            case 'Em aberto':
                variant = 'warning';
                break;
            case 'Ag. conf.':
                variant = 'primary';
                break;
            default:
                variant = 'secondary';
        }
        return <Badge bg={variant}>{status.toLowerCase()}</Badge>;
    };

    if (loading) {
        return (
            <Container className="mt-5">
                <Spinner animation="border" role="status">
                    <span className="sr-only">Loading...</span>
                </Spinner>
            </Container>
        );
    }

    if (error) {
        return (
            <Container className="mt-5">
                <Alert variant="danger">
                    Houve um problema ao obter os pedidos. Por favor, tente novamente mais tarde.
                </Alert>
            </Container>
        );
    }

    return (

        <>
            <Navbar />
            <Container className="mt-page">
                <h2>Pedidos Pendentes de Envio</h2>
                <Table striped bordered hover>
                    <thead>
                        <tr>
                            <th>Order</th>
                            <th>Data</th>
                            <th>Cliente</th>
                            <th>Status</th>
                            <th>Conta</th>
                            <th>Plataforma</th>
                            <th>Data Despacho</th>
                            <th>Ações</th>
                        </tr>
                    </thead>
                    <tbody>
                        {orders.map((order) => (
                            <tr key={order.pedido}>
                                <td>{order.pedido}</td>
                                <td>{formatDate(order.data)}</td>
                                <td>{order.cliente.toLowerCase()}</td>
                                <td>{renderStatusBadge(order.status)}</td>
                                <td>{order.nome_conta.toLowerCase()}</td>
                                <td>{order.plataforma.toLowerCase()}</td>
                                <td>{formatDate(order.data_despacho)}</td>
                                <td>
                                    <OverlayTrigger
                                        placement="top"
                                        overlay={<Tooltip id={`tooltip-edit-${order.pedido}`}>Editar</Tooltip>}
                                    >
                                        <Button
                                            variant="warning"
                                            as={Link}
                                            to={`/pedido/editar/${order.pedido}`}
                                            size="sm"
                                            style={{ marginRight: '5px' }}
                                        >
                                            <FaEdit style={{ fontSize: '12px' }} />
                                        </Button>
                                    </OverlayTrigger>

                                    <OverlayTrigger
                                        placement="top"
                                        overlay={<Tooltip id={`tooltip-nfe-${order.pedido}`}>Navegar até NFE</Tooltip>}
                                    >
                                        <Button
                                            variant="warning"
                                            onClick={() => handleNfe(order.id_loja, order.id_nfe)}
                                            size="sm"
                                            style={{ marginRight: '5px' }}
                                        >
                                            <FaFilePdf style={{ fontSize: '12px' }} />
                                        </Button>
                                    </OverlayTrigger>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </Container>
        </>
    );
};

export default PendingOrders;
